import CardForm from "./Card";
import CryptoBackupForm from "./CryptoBackup";
import IdentityForm from "./Identity";
import PasswordForm from "./Password";

const cipherFormComponents = {
  CardForm,
  CryptoBackupForm,
  IdentityForm,
  PasswordForm,
}

export default cipherFormComponents;